import { IPaymentSystem } from "../entryes/panel/Courses/GroupSettings/types";
import http from "./client";


export async function getPaymentMethods(): Promise<{
  methodsWithTitles: Array<IPaymentSystem>
  uri: string;
}> {
  const res = await http.get('/api/paymentsystems/oklist');
  return res.data;
}